import { useState, useCallback } from "react";

const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info",
    title: "",
    duration: 6000,
    position: { vertical: "top", horizontal: "right" },
  });

  const showToast = useCallback((message, severity = "info", options = {}) => {
    setToast({
      open: true,
      message,
      severity,
      title: options.title || "",
      duration: options.duration || 6000,
      position: options.position || { vertical: "top", horizontal: "right" },
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  const success = useCallback(
    (message, options = {}) => {
      showToast(message, "success", options);
    },
    [showToast]
  );

  const error = useCallback(
    (message, options = {}) => {
      showToast(message, "error", options);
    },
    [showToast]
  );

  const warning = useCallback(
    (message, options = {}) => {
      showToast(message, "warning", options);
    },
    [showToast]
  );

  const info = useCallback(
    (message, options = {}) => {
      showToast(message, "info", options);
    },
    [showToast]
  );

  return {
    toast,
    showToast,
    hideToast,
    success,
    error,
    warning,
    info,
  };
};

export default useToast;
